module.exports = __webpack_public_path__ + "img/process7.eedf9a7d.png";